<template>
  <v-content class="mx-4">
    <v-layout>
      <v-flex my-2 style="text-align: left;">
        <v-icon style="color: #BDBDBD;">arrow_right</v-icon>
        <v-btn text class="px-1">
          <span style="color: #BDBDBD;">จัดการหน้าช่วยเหลือ</span>
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout class="button-taps">
      <v-flex shrink style="text-align: left;">
        <v-btn class="mr-1" @click="tab = 1" :class="{active: tab === 1}"
               style="box-shadow: none;color: white;border-bottom-left-radius: unset;border-bottom-right-radius: unset;">
          จัดการหน้าช่วยเหลือ
        </v-btn>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex xs12 py-4 px-3 style="text-align: left;color: white;background-color: #84A2A8;">
        <v-layout>
          <v-flex shrink mr-4>
            <span style="font-size: 20px;font-weight: bold;">ปัญหาที่พบบ่อย?</span>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>

    <v-layout>
      <v-flex my-4>
        <vue-editor
          v-model="textQuestion"
          :editorToolbar="fullToolbar"
        >
        </vue-editor>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex mb-4>
        <v-btn color="#527281" dark @click="onSubmitQuestion()">
          บันทึก
        </v-btn>
      </v-flex>
    </v-layout>
  </v-content>

</template>

<script>
    import Service from "../service";
    import { VueEditor, Quill } from 'vue2-editor'
    import Swal from 'sweetalert2'

    export default {
        components: {
            VueEditor
        },
        name: "ManageHelp",
        computed: {
        },
        data: () => ({
            tab: 1,
            textQuestion: "",
            id: '',
            fullToolbar: [
                [{ font: [] }],

                [{ header: [false, 1, 2, 3, 4, 5, 6] }],

                [{ size: ["small", false, "large", "huge"] }],

                ["bold", "italic", "underline", "strike"],

                [
                    { align: "" },
                    { align: "center" },
                    { align: "right" },
                    { align: "justify" }
                ],

                [{ header: 1 }, { header: 2 }],

                ["blockquote", "code-block"],

                [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],

                [{ script: "sub" }, { script: "super" }],

                [{ indent: "-1" }, { indent: "+1" }],

                [{ color: [] }, { background: [] }],

                // ["link", "image", "video", "formula"],

                // [{ direction: "rtl" }],

                ["clean"]
            ],
        }),
        created() {
            this.getQa();
        },
        methods: {
            getQa() {
                Service.Common.getQa().then(res => {
                    this.textQuestion = res.html
                    this.id = res.id

                })
            },
            onSubmitQuestion() {
                Service.Common.saveQA({html:this.textQuestion,id:this.id}).then(res => {
                    Swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: res,
                        showConfirmButton: false,
                        timer: 1500
                    })
                })
            }
        }
    }
</script>

<style lang="scss">
  .bar-chart {
    .v-input__control {
      min-height: auto !important;
      border-radius: 20px !important;
    }
  }
  .pie-chart {
    .square {
      width: 12px;
      height: 12px;
      margin-top: 2px;
    }
    .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
      color: #527281;
    }
  }
</style>
